import { Routes } from '@angular/router';
import { AppAuthGuard, RoutingData, SemanticCode } from '@selfai-platform/shared';

export const aggregatorRouting: Routes = [
  {
    path: 'aggregators',
    canActivate: [AppAuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../components/aggregator-route-list').then((m) => m.AggregatorRouteListComponentModule),
        pathMatch: 'full',
        data: { semanticCode: SemanticCode.AggregatorList } as RoutingData,
      },
      {
        path: ':uuid',
        loadChildren: () =>
          import('../components/aggregator-camel-editor').then((m) => m.AggregatorCamelEditorComponentModule),
        data: { semanticCode: SemanticCode.AggregatorEditor } as RoutingData,
      },
    ],
  },
];
